import { SendOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Tag } from 'antd';

import { InfoBlock } from 'app/components/commons/InfoBlock/InfoBlock';
import type { BookingDetails } from 'app/typings/core/admin/bookings/booking';
import { dateAndHour } from 'app/utils/dates';

import { formatReservationStatus } from './utils';

type Props = {
  bookingDetails: BookingDetails;
  resendUserConfirmationMail: () => void;
  resendHotelConfirmationMail: () => void;
};

export const Reservation = ({
  bookingDetails,
  resendUserConfirmationMail,
  resendHotelConfirmationMail,
}: Props) => {
  const { label: reservationLabel, color: reservationColor } =
    formatReservationStatus(bookingDetails.status);

  return (
    <InfoBlock
      title="Reservation"
      actions={
        <>
          <Popconfirm
            title={`You're going to resend the confirmation to ${bookingDetails.customerData.email}`}
            onConfirm={resendUserConfirmationMail}
            okText="Send"
            cancelText="Cancel"
            placement="bottom"
            getPopupContainer={(trigger) =>
              trigger.parentElement as HTMLElement
            }
          >
            <Button icon={<SendOutlined />}>User confirmation</Button>
          </Popconfirm>

          <Popconfirm
            title={`You're going to resend the confirmation to the hotel`}
            onConfirm={resendHotelConfirmationMail}
            okText="Send"
            cancelText="Cancel"
            placement="bottom"
            getPopupContainer={(trigger) =>
              trigger.parentElement as HTMLElement
            }
          >
            <Button icon={<SendOutlined />}>Hotel confirmation</Button>
          </Popconfirm>
        </>
      }
      rows={[
        { label: 'ID', value: bookingDetails.id },
        { label: 'Code', value: bookingDetails.code },
        {
          label: 'Status',
          value: <Tag color={reservationColor}>{reservationLabel}</Tag>,
        },
        { label: 'Created at', value: dateAndHour(bookingDetails.createdAt) },
        {
          label: 'Check in',
          value: dateAndHour(bookingDetails.checkIn),
        },
        {
          label: 'Check out',
          value: dateAndHour(bookingDetails.checkOut),
        },
      ]}
    />
  );
};
